import Button from "@mui/material/Button";
import Checkbox from "@mui/material/Checkbox";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import FormControlLabel from "@mui/material/FormControlLabel";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import { reduce } from "et3-type-guards";

import i18n from "../../../../constants/i18n";
import { withLiteObserverAndTheme } from "../../../../core/et3-enhanced-render";
import getCorePopUpStore from "../../../../stores/core/core-popup-store";
import getKhattabatMatchingStore from "../../../../stores/khattabat-stores/matching-stores";
import getKhattabat101MGeneralStore from "../../../../stores/khattabat-stores/101m-stores/general-101m-store";

const KhattabatMatchingResultsPopUp = withLiteObserverAndTheme(() => {
  const matchesIds = reduce(
    () => getKhattabatMatchingStore().matchesIds.get(),
    []
  );

  const selectedMatchesCount = reduce(
    () => getKhattabatMatchingStore().selectedMatchesCount.get(),
    0
  );

  const isAllSelected =
    matchesIds.length > 0 && selectedMatchesCount === matchesIds.length;

  return (
    <Dialog
      open
      fullWidth
      maxWidth="sm"
      scroll="paper"
      onClose={() => getCorePopUpStore().closeConfirmationPopUps()}
    >
      <DialogTitle>{i18n.get("KHATTABAT_MATCHING_RESULTS")}</DialogTitle>
      <Stack
        direction="row"
        justifyContent="space-between"
        alignItems="center"
        sx={{ px: 3 }}
      >
        <Typography variant="body1">
          {`${i18n.get("KHATTABAT_SELECTED_MATCHES")}: ${selectedMatchesCount}`}
        </Typography>
        <FormControlLabel
          label={i18n.get("SELECT_ALL")}
          control={
            <Checkbox
              checked={isAllSelected}
              indeterminate={selectedMatchesCount > 0 && !isAllSelected}
              onChange={() => {
                getKhattabat101MGeneralStore().toggleIsMatchesIdsSelectedAll();
                getKhattabatMatchingStore().setSelectedMatchesIds(
                  isAllSelected ? [] : matchesIds
                );
              }}
            />
          }
        />
      </Stack>
      <DialogContent dividers>
        <List dense disablePadding>
          {matchesIds.map((userID) => {
            const labelId = `khattabat-matching-result-${userID}`;

            return (
              <ListItem key={userID} disablePadding>
                <ListItemButton
                  onClick={() =>
                    getKhattabatMatchingStore().toggleSelectedMatchUser(userID)
                  }
                >
                  <ListItemIcon>
                    <Checkbox
                      edge="start"
                      checked={getKhattabatMatchingStore().isMatchUserSelected(
                        userID
                      )}
                      tabIndex={-1}
                      disableRipple
                      slotProps={{ input: { "aria-labelledby": labelId } }}
                    />
                  </ListItemIcon>
                  <ListItemText id={labelId} primary={userID} />
                </ListItemButton>
              </ListItem>
            );
          })}
        </List>
      </DialogContent>
      <DialogActions>
        <Button
          variant="contained"
          onClick={() => getCorePopUpStore().closeConfirmationPopUps()}
        >
          {i18n.get("CONFIRM")}
        </Button>
      </DialogActions>
    </Dialog>
  );
});

export default KhattabatMatchingResultsPopUp;
